import { render, staticRenderFns } from "./Stamps.vue?vue&type=template&id=dc29f538&scoped=true&"
import script from "./Stamps.vue?vue&type=script&lang=js&"
export * from "./Stamps.vue?vue&type=script&lang=js&"
import style0 from "./Stamps.vue?vue&type=style&index=0&id=dc29f538&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc29f538",
  null
  
)

export default component.exports